module.exports = __webpack_public_path__ + "static/media/compare_95.bdc86987.svg";